import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/elementRest.css'
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(Element, { locale })
